export default "__VITE_ASSET__SXn4QCZL__"